import React, { useState, useRef } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import styles from './PricingForm.module.css';
import config from '../../../../../config';
import { getAuthToken } from '../../../../utils/auth';

const putUpdatePrice = async (publisherId, price) => {
  const accessToken = getAuthToken();

  const payload = price;

  const response = await fetch(
    `${config.ApiBaseUrl}/publisher/${publisherId}/updatePriceSetting`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const PricingForm = () => {
  const publisherId = useSelector((state) => state.user.publisher?.id);
  const minPrice = useSelector((state) => state.user.publisher?.minPrice);
  const tipJarPrice = useSelector(
    (state) => state.user.publisher?.tipJarPriceOptions?.prices
  );
  const currCode = useSelector(
    (state) => state.user.publisher?.bookCurrency?.code
  );

  const [touched, setTouched] = useState(false);

  const PWInput = useRef();
  const TJLowInput = useRef();
  const TJMedInput = useRef();
  const TJhighInput = useRef();

  // const [price, setPrice] = useState({
  //   paywallPrice: minPrice,
  //   tipJarPrice: tipJarPrice,
  // });

  let price = {
    paywallPrice: minPrice,
    tipJarPrice,
  };

  const handleTouch = () => {
    setTouched(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // setPrice({
    //   paywallPrice: PWInput.current.value,
    //   tipJarPrice: [
    //     TJLowInput.current.value,
    //     TJMedInput.current.value,
    //     TJhighInput.current.value,
    //   ],
    // });

    price = {
      paywallPrice: PWInput.current.value,
      tipJarPrice: [
        TJLowInput.current.value,
        TJMedInput.current.value,
        TJhighInput.current.value,
      ],
    };

    if (publisherId) {
      toast.promise(putUpdatePrice(publisherId, price), {
        loading: 'setting default price...',
        success: 'default price set!',
        error: 'Error while setting default price!',
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles['pricing-form']}>
      <div id={styles['paywall-price']} className={styles['input-item']}>
        <h5>
          Paywall Price<span>({currCode})</span>
        </h5>
        <input
          type="number"
          step="0.01"
          min="0.5"
          required
          defaultValue={price.paywallPrice}
          ref={PWInput}
          onFocus={handleTouch}
        />
      </div>
      <div id={styles['tipjar-price']} className={styles['input-item']}>
        <h5>
          TipJar Price<span>({currCode})</span>
        </h5>
        <div className={styles.input}>
          <label htmlFor="low">low</label>
          <input
            id="low"
            type="number"
            step="0.01"
            min="0.5"
            required
            defaultValue={price.tipJarPrice[0]}
            ref={TJLowInput}
            onFocus={handleTouch}
          />
        </div>
        <div className={styles.input}>
          <label htmlFor="med">medium</label>
          <input
            id="med"
            type="number"
            step="0.01"
            min="0.5"
            required
            defaultValue={price.tipJarPrice[1]}
            ref={TJMedInput}
            onFocus={handleTouch}
          />
        </div>
        <div className={styles.input}>
          <label htmlFor="high">high</label>
          <input
            id="high"
            type="number"
            step="0.01"
            min="0.5"
            required
            defaultValue={price.tipJarPrice[2]}
            ref={TJhighInput}
            onFocus={handleTouch}
          />
        </div>
      </div>
      <button type="submit" id={styles.form__submit} disabled={!touched}>
        Set Price
      </button>
    </form>
  );
};

export default PricingForm;
